import React from 'react';
import registeredComponent from "../../utils/registeredComponent";
import {duckify, filterDuck} from "../../utils/duckify";
import {billingAccounts as billingAccountsDuck} from "../../ducks";

import BillingAccountAccessPicker from './BillingAccountAccessPicker';

const BillingPayerToBillingAccountMapper = ({kidContactId, payerContact, billingPayer, billingAccounts}) => {
  return <React.Fragment>
    {
      // SHOULD only be one billing account per payer, but in theory this could be more than one
      billingAccounts.map((account, i) => {
      return <BillingAccountAccessPicker key={i} kidContactId={kidContactId} payerContact={payerContact} billingPayer={billingPayer} billingAccount={account}/>;
    })}
  </React.Fragment>;
}

const mapDucksToProps = (props) => {
  return {
    billingAccounts: filterDuck(billingAccountsDuck, { payer_contact_id: props.payerContact.id })
  }
};

export default registeredComponent('BillingPayerToBillingAccountMapper')(duckify(mapDucksToProps, () => ({}), () => ({}))(BillingPayerToBillingAccountMapper));
